import { isEmpty } from 'lodash';
import exportConfig from '../config/getConfig';

export const API_URL = exportConfig.REACT_APP_API_URL;
if (isEmpty(API_URL)) {
  throw new Error('API_URL is not defined');
}
